"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intercepterMessageMapping = void 0;
var _genericFunction = require("../genericFunction");
var intercepterMessageMapping = [{
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand",
  method: "post",
  message: "Brand created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand",
  method: "put",
  message: "Brand updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/organization",
  method: "post",
  message: "Tenant created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/organization",
  method: "put",
  message: "Tenant updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/disable",
  method: "put",
  message: "System disabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/enable",
  method: "put",
  message: "System enabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/clean",
  method: "delete",
  message: "System data cleared/deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/delete",
  method: "delete",
  message: "System deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/restore",
  method: "put",
  message: "System restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/root",
  method: "post",
  message: "Asset root node created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/root",
  method: "post",
  message: "Content Panel root node created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates",
  method: "post",
  message: "Email template created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates",
  method: "put",
  message: "Email template updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/delete/hard",
  method: "delete",
  message: "Email template deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/organization/platform",
  method: "put",
  message: "Cloud details updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform",
  method: "post",
  message: "User created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform",
  method: "put",
  message: "User updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/status/deactivate",
  method: "put",
  message: "User disabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/status/activate",
  method: "put",
  message: "User enabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/delete/hard",
  method: "delete",
  message: "User deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/device/delete/hard",
  method: "delete",
  message: "Device deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/reset-password",
  method: "put",
  message: "Password reset."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/role",
  method: "post",
  message: "Role created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand",
  method: "delete",
  message: "Brand deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/organization/info",
  method: "put",
  message: "Element updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/organization/vimeo",
  method: "put",
  message: "Element updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates",
  method: "post",
  message: "Broadcast created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates",
  method: "put",
  message: "Broadcast updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates",
  method: "delete",
  message: "Broadcast deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents",
  method: "post",
  message: "Element created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents",
  method: "put",
  message: "Element updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette",
  method: "post",
  message: "Palette created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/delete/hard",
  method: "delete",
  message: "Brand deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/standard/template",
  method: "put",
  message: "Template updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/standard/template",
  method: "post",
  message: "Template created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/standard/template",
  method: "delete",
  message: "Template deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type",
  method: "post",
  message: "Fund type created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type",
  method: "put",
  message: "Fund type(s) updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type",
  method: "delete",
  message: "Fund type deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund",
  method: "post",
  message: "Fund description created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund",
  method: "put",
  message: "Fund description updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund",
  method: "delete",
  message: "Fund description deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance",
  method: "post",
  message: "FY performance data created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance",
  method: "put",
  message: "FY performance data updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance",
  method: "delete",
  message: "FY performance data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor",
  method: "post",
  message: "FY donor data created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor",
  method: "put",
  message: "FY donor data updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor",
  method: "delete",
  message: "FY donor data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type",
  method: "post",
  message: "Impact type created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type",
  method: "put",
  message: "Impact type updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type",
  method: "delete",
  message: "Impact type deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact",
  method: "post",
  message: "Fund impact created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact",
  method: "put",
  message: "Fund impact updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact",
  method: "delete",
  message: "Fund impact deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel",
  method: "post",
  message: "Rdt panel html created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel",
  method: "put",
  message: "Rdt panel html updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel",
  method: "delete",
  message: "Rdt panel html deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping",
  method: "post",
  message: "Map rdt panel created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping",
  method: "put",
  message: "Map rdt panel updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping",
  method: "delete",
  message: "Map rdt panel deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/report",
  method: "post",
  message: "Report printbridge created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/report",
  method: "put",
  message: "Report printbridge updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/report",
  method: "delete",
  message: "Report printbridge deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/site",
  method: "put",
  message: "Content Panel printbridge updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/site",
  method: "post",
  message: "Content Panel printbridge created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/site",
  method: "delete",
  message: "Content Panel printbridge deleted."
}, /*** System Admin Generic message with custom ***/

{
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/status/deactivate",
  method: "put",
  message: "User disabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/status/activate",
  method: "put",
  message: "User enabled."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund",
  method: "post",
  message: "Fund created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund",
  method: "put",
  message: "Fund updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund",
  method: "delete",
  message: "Fund deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance",
  method: "put",
  message: "FY performance data updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance",
  method: "post",
  message: "FY performance data added."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance",
  method: "delete",
  message: "FY performance data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors",
  method: "post",
  message: "FY donor data added."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors",
  method: "put",
  message: "FY donor data updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors",
  method: "delete",
  message: "FY donor data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact",
  method: "post",
  message: "FY impact data created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact",
  method: "put",
  message: "FY impact data updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact",
  method: "delete",
  message: "FY impact data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/delete-all",
  method: "delete",
  message: "All fund deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/brand/assign",
  method: "put",
  message: "Brand admin settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors/delete-all",
  method: "delete",
  message: "All FY donor data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/application/assign",
  method: "put",
  message: "Application admin settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/data/assign",
  method: "put",
  message: "Data admin settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/report/assign",
  method: "put",
  message: "Report admin settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/content/assign",
  method: "put",
  message: "Content admin settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/group",
  method: "post",
  message: "New group created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/group",
  method: "put",
  message: "Group membership edited."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/group",
  method: "put",
  message: "Group renamed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance/delete-all",
  method: "delete",
  message: "All FY performance data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/group/delete/hard",
  method: "delete",
  message: "Group deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/delete-all",
  method: "delete",
  message: "All FY impact data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/general/passcode",
  method: "put",
  message: "Record settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/setting/site",
  method: "put",
  message: "Site settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/setting/survey",
  method: "put",
  message: "Survey settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/data-schema",
  method: "put",
  message: "Data schema settings saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/setting/report",
  method: "put",
  message: "Report settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/api-key",
  method: "delete",
  message: "API access key deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user",
  method: "post",
  message: "User created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records",
  method: "post",
  message: "New record created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records",
  method: "put",
  message: "Record information updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user",
  method: "put",
  message: "User settings updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/records/delete/soft",
  method: "delete",
  message: "Record soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/delete/hard",
  method: "delete",
  message: "User deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user-profile",
  method: "put",
  message: "User profile updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/mail",
  method: "post",
  message: "Notification sent."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/delete/soft",
  method: "delete",
  message: "Record soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/access-permission",
  method: "put",
  message: "Brand access updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/bulk/delete/hard",
  method: "put",
  message: "Record(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/site/greeting-message",
  method: "put",
  message: "Greeting message updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/site/header-image",
  method: "put",
  message: "Greeting image updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/site/cp-site-list",
  method: "put",
  message: "Default content stack updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/report/greeting-mesage",
  method: "put",
  message: "Greeting message updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/report/header-image",
  method: "put",
  message: "Greeting image updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/report/cp-report-list",
  method: "put",
  message: "Default content stack updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/record",
  method: "delete",
  message: "Record asset deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/record",
  method: "put",
  message: "Record asset updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/record",
  method: "post",
  message: "Record asset created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/funds/link",
  method: "post",
  message: "Linked fund(s) updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/donors/passcode",
  method: "put",
  message: "Passcode updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view",
  method: "post",
  message: "New folder created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view",
  method: "put",
  message: "Folder moved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view/delete/soft/restore",
  method: "put",
  message: "Content panel restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view",
  method: "delete",
  message: "Content panel deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder",
  method: "post",
  message: "New folder created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder",
  method: "put",
  message: "Folder moved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset",
  method: "put",
  message: "Asset renamed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset",
  method: "delete",
  message: "Asset deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder/delete/soft",
  method: "delete",
  message: "Asset soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder/delete/soft/restore",
  method: "put",
  message: "Asset restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report",
  method: "post",
  message: "Report built."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site",
  method: "post",
  message: "Site built."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/active-broadcast",
  method: "put",
  message: "Revised alert pushed across the system."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/active-broadcast/notification",
  method: "post",
  message: "Broadcast alerts activated and notification sent to users."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/active-broadcast",
  method: "delete",
  message: "Broadcast alert removed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel",
  method: "delete",
  message: "Content Panel deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/copy-content",
  method: "post",
  message: "Duplicate placed in drafts."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site",
  method: "delete",
  message: "Site deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/access-permission",
  method: "put",
  message: "Access updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/access-permission",
  method: "put",
  message: "Access updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/restricted",
  method: "put",
  message: "Report restricted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/unrestricted",
  method: "put",
  message: "Report access allowed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/resume",
  method: "put",
  message: "Report resumed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/pause",
  method: "put",
  message: "Report paused."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report",
  method: "delete",
  message: "Report deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/resume",
  method: "put",
  message: "Site is live."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/pause",
  method: "put",
  message: "Site paused."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/unrestricted",
  method: "put",
  message: "Site access allowed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/restricted",
  method: "put",
  message: "Site restricted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/approve",
  method: "put",
  message: "Report approved & URL activated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/approve",
  method: "put",
  message: "Site approved & URL activated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/delete/hard",
  method: "delete",
  message: "Record deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/panel-sequence",
  method: "put",
  message: "Impact reordered."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/funds/link/single",
  method: "post",
  message: "Record added."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/funds/unlink/single",
  method: "delete",
  message: "Record unlinked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/site/data-and-alert/alert-notification",
  method: "put",
  message: "Alert notification saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/report/data-and-alert/alert-notification",
  method: "put",
  message: "Alert notification saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/archive",
  method: "delete",
  message: "Archived data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/session",
  method: "delete",
  message: "Activity deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/notification",
  method: "post",
  message: "Content Panel published; Notification sent."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/draft",
  method: "post",
  message: "Content Panel saved on draft."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/reset-password/delegate",
  method: "put",
  message: "Password updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/general/reset-password",
  method: "put",
  message: "Password updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/submit",
  method: "put",
  message: "Site submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/submit",
  method: "put",
  message: "Report submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/authorize-device",
  method: "put",
  message: "Device authorized."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/edit/brand/change",
  method: "put",
  message: "Theme applied and saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/edit",
  method: "put",
  message: "Site saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/edit",
  method: "put",
  message: "Report saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/update",
  method: "delete",
  message: "Report Update deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/edit/goto-update",
  method: "put",
  message: "Tab switched."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/public/forgot-passcode/mail",
  method: "post",
  message: "System administrator notified, Passcode to be sent ASAP."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/donors/passcode/magic-link",
  method: "post",
  message: "Passcode set."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/donors/email",
  method: "put",
  message: "Email submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/editor-notification",
  method: "post",
  message: "Alert set."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/upload/image/fund/default",
  method: "post",
  message: "Default asset saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/upload/image/impact/default",
  method: "post",
  message: "Default asset saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/upload/image/printbridge/default",
  method: "post",
  message: "Default asset saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/delete/soft",
  method: "delete",
  message: "User soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/delete/soft/restore",
  method: "put",
  message: "User restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/delete/soft",
  method: "delete",
  message: "Report soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/delete/soft/restore",
  method: "put",
  message: "Report restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/delete/soft",
  method: "delete",
  message: "Site soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/delete/soft/restore",
  method: "put",
  message: "Site restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/delete/soft/restore",
  method: "put",
  message: "FY impact data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/delete/soft",
  method: "delete",
  message: "FY impact data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/delete/soft",
  method: "delete",
  message: "Fund soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/delete/soft/restore",
  method: "put",
  message: "Fund restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/donors/passcode",
  method: "get",
  message: "Reset passcode for reveal."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance/delete/soft",
  method: "delete",
  message: "FY performance data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance/delete/soft/restore",
  method: "put",
  message: "FY performance data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors/delete/soft/restore",
  method: "put",
  message: "FY donor data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/crm/pause-or-resume",
  method: "put",
  message: "Application updated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/crm-field/mapping/bulk",
  method: "put",
  message: "Map data field saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/crm-field/mapping/bulk",
  method: "put",
  message: "Map data field saved."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/crm-field/mapping/test-fields",
  method: "get",
  message: "Test succeed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/delete/soft",
  method: "delete",
  message: "User soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/totp/remove",
  method: "put",
  message: "Device removed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/totp/public/validate-setup",
  method: "post",
  message: "Device Paired."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/totp/validate-setup",
  method: "post",
  message: "Device Paired."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/totp/remove",
  method: "put",
  message: "Device Removed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/admin/platform/delete/soft/restore",
  method: "put",
  message: "User restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/delete/soft",
  method: "delete",
  message: "Email template soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/delete/soft/restore",
  method: "put",
  message: "Email template restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates/delete/soft",
  method: "delete",
  message: "Broadcast soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates/delete/soft/restore",
  method: "put",
  message: "Broadcast restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/delete/soft",
  method: "delete",
  message: "Brand soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/delete/soft/restore",
  method: "put",
  message: "Brand restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template/delete/soft",
  method: "delete",
  message: "Content panel soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template/delete/soft/restore",
  method: "put",
  message: "Content panel restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template",
  method: "delete",
  message: "Content panel deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type/delete/soft",
  method: "delete",
  message: "Fund type soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/delete/soft",
  method: "delete",
  message: "Access criteria soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type/delete/soft/restore",
  method: "put",
  message: "Fund type restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type/delete/soft",
  method: "delete",
  message: "Impact type soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/delete/hard",
  method: "delete",
  message: "Access criteria deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/delete/soft/restore",
  method: "put",
  message: "Access criteria restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance/delete/soft",
  method: "delete",
  message: "Access criteria soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type/delete/soft/restore",
  method: "put",
  message: "Impact type restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/delete/soft",
  method: "delete",
  message: "Rdt panel html soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance/delete/hard",
  method: "delete",
  message: "Access criteria deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/performance/delete/soft/restore",
  method: "put",
  message: "Access criteria restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor/delete/soft",
  method: "delete",
  message: "Access criteria soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/delete/soft/restore",
  method: "put",
  message: "Rdt panel html restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping/delete/soft",
  method: "delete",
  message: "Map rdt panel soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor/delete/hard",
  method: "delete",
  message: "Access criteria deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/donor/delete/soft/restore",
  method: "put",
  message: "Access criteria restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact/delete/soft",
  method: "delete",
  message: "Access criteria soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping/delete/soft/restore",
  method: "put",
  message: "Map rdt panel restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/site/delete/soft",
  method: "delete",
  message: "Content panel printbridge soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report/delete/soft",
  method: "delete",
  message: "Report printbridge soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report",
  method: "delete",
  message: "Report printbridge deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/site/delete/soft/restore",
  method: "put",
  message: "Content panel printbridge restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report/delete/soft/restore",
  method: "put",
  message: "Report printbridge restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact/delete/hard",
  method: "delete",
  message: "Access criteria deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/fund/impact/delete/soft/restore",
  method: "put",
  message: "Access criteria restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette/delete/soft",
  method: "delete",
  message: "Palette soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette/delete/soft/restore",
  method: "put",
  message: "Palette restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/report/delete/soft",
  method: "delete",
  message: "Report element soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/delete/soft",
  method: "delete",
  message: "Site element soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/delete/hard",
  method: "delete",
  message: "Site element deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/delete/soft/restore",
  method: "put",
  message: "Site element restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/report/delete/soft/restore",
  method: "put",
  message: "Report element restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette",
  method: "delete",
  message: "Palette deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/report/delete/hard",
  method: "delete",
  message: "Report element deleted."
}];
exports.intercepterMessageMapping = intercepterMessageMapping;